// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Settings_upper__VkmmB {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
@media only screen and (max-width: 37.5em) {
  .Settings_upper__VkmmB {
    margin-top: 4rem;
    flex-direction: column;
  }
}
.Settings_upper__title__k8wwl {
  width: 38rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Settings_upper__title_shape__X3-hw {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--default-font-h2);
  font-weight: 700;
  background-color: var(--color-primary-7);
  width: 9rem;
  height: 9rem;
  border-radius: 9rem;
  margin-bottom: 2rem;
}

@media only screen and (max-width: 37.5em) {
  .Settings_main__nav__7J4Il {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
.Settings_main__nav__7J4Il > :not(:last-child) {
  margin-bottom: 2rem;
}
.Settings_main__nav_item__XO2S4 {
  width: 38rem;
  border: 1px solid var(--color-primary);
  border-radius: 1rem;
  padding: 1.9rem 1rem;
  display: grid;
  grid-template-columns: 1fr 8fr 1fr;
  gap: 1rem;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
}
.Settings_main__nav_item__XO2S4:hover {
  border: 2px solid var(--color-primary);
  color: var(--color-primary);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  background-color: var(--color-primary-3);
}
.Settings_main__nav_item__icon__Qs5-6 {
  font-size: 2.5rem;
  transition: all 0.2s;
}
.Settings_main__nav_item__icon2__mFi3W {
  font-size: 2.5rem;
  transform: rotateZ(90deg);
  transition: all 0.2s;
}

@media only screen and (max-width: 37.5em) {
  .Settings_sub__nav__HWTrS {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
.Settings_sub__nav__HWTrS > :not(:last-child) {
  margin-bottom: 2rem;
}
.Settings_sub__nav_item__OCNaP {
  width: 36rem;
  border: 1px solid var(--color-dark);
  border-radius: 1rem;
  padding: 1.9rem 1rem;
  display: grid;
  grid-template-columns: 1fr 8fr 1fr;
  gap: 1rem;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
  margin-left: 2rem;
}
.Settings_sub__nav_item__OCNaP:hover {
  border: 2px solid var(--color-dark);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  background-color: var(--color-light-gry);
  font-weight: 700;
}
.Settings_sub__nav_item__icon__aS4MS {
  font-size: 2.5rem;
}

.Settings_bus__FfqYA {
  margin-top: 1rem;
  width: 40rem;
}
.Settings_bus__head__\\+iwa1 {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-bottom: 2rem;
}
.Settings_bus__head__\\+iwa1 > :not(:last-child) {
  margin-right: 2rem;
}
.Settings_bus__edit__u-pM8 {
  display: flex;
  flex-direction: column;
  font-size: 2.5rem;
  align-items: center;
  cursor: pointer;
}
.Settings_bus__edit__u-pM8 > :not(:last-child) {
  margin-bottom: 1rem;
}
.Settings_bus__edit__u-pM8:hover {
  color: var(--color-primary);
}
.Settings_bus__details__UXQRr > :not(:last-child) {
  margin-bottom: 2rem;
}
.Settings_bus__img__H3nvL {
  display: flex;
  justify-content: center;
}
.Settings_bus__logo__cbPcH {
  height: 7rem;
}

.Settings_sec__img__UBa8n {
  width: 25rem;
  margin-bottom: 3rem;
}
.Settings_sec__img_contain__pg1nC {
  display: flex;
  justify-content: center;
}
.Settings_sec__center__TahHv {
  width: 40rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Settings_am__img__1DqEQ {
  height: 10rem;
  border-radius: 10rem;
}
.Settings_am__img_contain__-SJHU {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12rem;
  height: 12rem;
  border-radius: 12rem;
  background-color: var(--color-primary-7);
}
.Settings_am__btn__9MQlO {
  display: flex;
  gap: 2rem;
}

.Settings_if__img__3br2T {
  height: 22rem;
}
.Settings_if__share__BsmS- {
  display: flex;
  font-size: var(--default-font-small);
}
.Settings_if__share_1__obhQz {
  background-color: var(--color-primary-7);
  width: 28rem;
  padding: 1.5rem 2rem;
  border-radius: 2rem 0 0 2rem;
  word-wrap: break-word;
}
.Settings_if__share_1__obhQz span {
  color: var(--color-primary);
}
.Settings_if__share_2__zcvCB {
  background-color: var(--color-primary);
  color: var(--color-white);
  width: 10rem;
  padding: 1.5rem 2rem;
  border-radius: 0 2rem 2rem 0;
  word-wrap: break-word;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
}

.Settings_logout__U3JnU {
  display: flex;
  gap: 2rem;
}

.Settings_cs__gIIaj {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Settings_cs__img__r1mT5 {
  height: 23rem;
}
.Settings_cs__menu__RE8EV {
  margin-top: 3rem;
}
.Settings_cs__menu__RE8EV > :not(:last-child) {
  margin-bottom: 2rem;
}
.Settings_cs__menu_main__3YUqa {
  display: flex;
  padding: 2.5rem 2rem;
  justify-content: space-between;
  align-items: center;
  font-size: 3rem;
  width: 42rem;
  border-radius: 1.5rem;
  cursor: pointer;
  transition: all 0.2s;
}
.Settings_cs__menu_main__3YUqa:hover {
  filter: brightness(1.05);
  border: 1px solid var(--color-primary);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.15);
}
.Settings_cs__menu_main__faq__nSrYx {
  background-color: var(--color-primary-3);
}
.Settings_cs__menu_main__send__OP8TA {
  background-color: var(--color-primary-7);
}
.Settings_cs__menu_main__speak__a8FDJ {
  background-color: var(--color-primary-8);
}
.Settings_cs__dials__mCgL- {
  display: flex;
  gap: 2rem;
  align-items: center;
  font-size: 3rem;
  margin-bottom: 2rem;
  cursor: pointer;
}
.Settings_cs__socials__eF8CK {
  display: flex;
  font-size: 3rem;
  justify-content: center;
  color: var(--color-primary);
}
.Settings_cs__socials__eF8CK > :not(:last-child) {
  margin-right: 2rem;
}
.Settings_cs__socials__eF8CK > * {
  cursor: pointer;
}
.Settings_cs__socials__eF8CK > *:hover {
  color: var(--color-primary-4);
}

.Settings_faq__eYSCI {
  width: 42rem;
}
.Settings_faq__line__acoxP {
  border-top: 1px solid var(--color-primary);
  margin: 1rem 0;
}

.Settings_pin__4qjSC {
  width: 38rem;
}
.Settings_pin__4qjSC > :nth-child(3) {
  margin-left: 4rem;
}

.Settings_iconfig__CVqHf {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.Settings_iconfig__menu__JlARv {
  margin-top: 3rem;
  transition: all 2s;
}
.Settings_iconfig__menu__JlARv > :not(:last-child) {
  margin-bottom: 2rem;
}
.Settings_iconfig__menu_main__F5odO {
  display: flex;
  padding: 2.5rem 2rem;
  justify-content: space-between;
  align-items: center;
  font-size: 3rem;
  width: 42rem;
  background-color: var(--color-primary-7);
  border-radius: 1.5rem;
  transition: all 0.2s;
  cursor: pointer;
}
.Settings_iconfig__menu_main__F5odO:hover {
  filter: brightness(1.05);
  border: 1px solid var(--color-primary);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.15);
}
.Settings_iconfig__settings__knJP- {
  padding: 2rem 1.8rem;
  animation: Settings_translateDown__EEHVR 0.5s;
}
.Settings_iconfig__settings_feature__fi1QQ {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
}
.Settings_iconfig__settings_feature__fi1QQ:not(:last-child) {
  margin: 2rem 0;
}
.Settings_iconfig__settings_feature_text__YiTrx {
  width: 80%;
  align-self: center;
}
.Settings_iconfig__beside__Rov1s {
  display: flex;
  justify-content: space-between;
  width: 38rem;
  flex-wrap: wrap;
}

.Settings_error__B\\+Z6D {
  font-size: var(--default-font-small);
  color: var(--color-error);
  padding-left: 2rem;
  font-weight: 400;
  margin: 1rem 0;
  width: 38rem;
}

@keyframes Settings_translateDown__EEHVR {
  0% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}
.Settings_kyc__list__OkdXD {
  display: flex;
  align-items: center;
  width: 38rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid var(--color-grey);
  margin-bottom: 2rem;
}
.Settings_kyc__list__icon__7d40V {
  font-size: 4rem;
  color: var(--color-green);
  background-color: var(--color-green-3);
  border-radius: 5rem;
  padding: 0.5rem;
  box-sizing: border-box;
  margin-right: 1rem;
}
.Settings_kyc__list__OkdXD span {
  width: 33rem;
  word-wrap: break-word;
}

.Settings_bicContainer__Jo9Bc {
  display: flex;
  justify-content: center;
  max-width: 36rem;
}
.Settings_bicContainer__bic__EYiXy {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
  width: 100%;
  max-width: 36rem;
}

.Settings_configDetails__f4LiO {
  display: grid;
  grid-template-columns: 55% 35%;
  max-width: 40rem;
  justify-content: center;
  justify-self: center;
  margin-bottom: 2rem;
  gap: 2rem;
  padding: 0 1rem;
}
.Settings_configDetails_btn__w9tUy {
  display: flex;
  justify-content: center;
  width: 100%;
}

.Settings_repeat__0X8Xw {
  display: flex;
  justify-content: space-between;
  width: 38rem;
}

.Settings_cards__FXfy5 {
  display: flex;
  width: 38rem;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--color-grey);
  justify-content: space-between;
}
.Settings_cards__FXfy5 img {
  height: 3rem;
  margin-right: 3rem;
}
.Settings_cards__beside__2Z3Xb {
  display: flex;
  align-items: center;
}
.Settings_cards__delete__k1TSq {
  display: flex;
  align-items: center;
  flex-direction: column;
  color: var(--color-error);
  cursor: pointer;
  font-size: 3rem;
}
.Settings_cards__delete__k1TSq:hover {
  font-weight: 700;
}
.Settings_cards__delete__k1TSq p {
  font-size: 1.4rem;
  color: var(--color-deep-red);
}

.Settings_paystackButton__iRlxX {
  width: 38rem;
  border-radius: 1rem;
  background-color: var(--color-primary);
  color: var(--color-white);
  font-weight: 700;
  box-sizing: border-box;
  padding: 1.9rem 2.2rem;
  justify-content: center;
  margin-top: 2rem;
}
.Settings_paystackButton_container__789dN {
  display: flex;
  justify-content: center;
}

.Settings_subscription__fOuW4 {
  width: 42rem;
}
.Settings_subscription__planSelect__7QnZ5 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: 100%;
  border-radius: 1rem;
  margin: 1rem 0;
  margin-bottom: 3rem;
  cursor: pointer;
}
.Settings_subscription__planSelect__7QnZ5 > * {
  padding: 1rem 0 1rem 0;
  text-align: center;
}
.Settings_subscription__planSelect__active__Pq8RP {
  background-color: var(--color-primary);
  color: var(--color-white);
  transition: all 0.4s;
  border: 1px solid var(--color-primary);
  font-weight: 700;
}
.Settings_subscription__planSelect__active__1__7C6nc {
  border-radius: 1rem 0 0 1rem;
}
.Settings_subscription__planSelect__active__2__jTmek {
  border-radius: 0 1rem 1rem 0;
}
.Settings_subscription__planSelect__inactive__53kkk {
  transition: all 0.4s;
  border: 1px solid var(--color-primary);
  color: var(--color-dark);
}
.Settings_subscription__planSelect__inactive__1__RL4vY {
  border-radius: 1rem 0 0 1rem;
}
.Settings_subscription__planSelect__inactive__2__AfVDX {
  border-radius: 0 1rem 1rem 0;
}
.Settings_subscription__planDetails__deselected__Dgcpu {
  border-radius: 1rem;
  background-color: var(--color-light);
  margin-bottom: 2rem;
  padding: 2rem;
  border: 1px solid var(--color-grey);
  cursor: pointer;
}
.Settings_subscription__planDetails__selected__2G0u4 {
  border-radius: 1rem;
  background-color: var(--color-primary-3);
  margin-bottom: 2rem;
  padding: 2rem;
  border: 1px solid var(--color-primary-4);
  cursor: pointer;
}
.Settings_subscription__planDetails__item__4DqSY {
  display: grid;
  grid-template-columns: min-content 1fr;
  gap: 1rem;
}
.Settings_subscription__save__upfLx {
  border-radius: 1rem;
  background-color: var(--color-light-red);
  color: var(--color-error);
  font-weight: 700;
  padding: 1rem;
  border: 1px solid var(--color-error);
  font-size: var(--default-font-small);
}
.Settings_subscription__summary__gznLZ {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}
.Settings_subscription__summary__item__v8OZ6 {
  background-color: var(--color-primary-3);
  padding: 1rem;
  border-radius: 1rem;
}
.Settings_subscription__img__DoUp2 {
  margin-bottom: 2rem;
  width: max-content;
}
.Settings_subscription__upgrade__rttVc {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}
.Settings_subscription__upgrade__item__3rFuK {
  background-color: var(--color-primary-3);
  padding: 1rem;
  border-radius: 1rem;
  height: 7.5rem;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
}
.Settings_subscription__upgrade__item__active__VrVXT {
  border: 2px solid var(--color-primary);
  border-radius: 1rem;
  padding: 1rem;
  transition: all 0.2s;
}

.Settings_ai__9WDvH {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 3rem 5rem 3rem 5rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  height: auto;
  gap: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
}
.Settings_ai__copy__geyfW {
  display: flex;
  font-size: 3rem;
  color: var(--color-white);
  cursor: pointer;
  background-color: var(--color-dark);
  padding: 1rem 2rem;
  border-radius: 0.5rem;
  align-items: center;
}
.Settings_ai__card__h0SAS {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  min-width: 80rem;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 2rem;
  border-radius: 1rem;
  background-color: var(--color-primary-3);
  gap: 1rem;
  scroll-behavior: auto;
}
@media only screen and (max-width: 43.75em) {
  .Settings_ai__card__h0SAS {
    height: auto;
    font-size: 2rem;
  }
}
.Settings_ai__card__align__RFxmd {
  display: flex;
  justify-content: space-between;
  max-width: 100%;
  flex-wrap: wrap;
}

.Settings_imageUpload__URHrl {
  height: 10rem;
}

.Settings_beside__7hxRx {
  display: flex;
  gap: 4rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Settings/Settings.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AADD;AAGC;EAND;IAOE,gBAAA;IACA,sBAAA;EAAA;AACF;AAEC;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAAF;AAEE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,wCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAAH;;AAOE;EADD;IAEE,aAAA;IACA,sBAAA;IACA,mBAAA;EAHD;AACF;AAKE;EACC,mBAAA;AAHH;AAME;EACC,YAAA;EACA,sCAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,kCAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAJH;AAMG;EACC,sCAAA;EACA,2BAAA;EACA,4CAAA;EACA,wCAAA;AAJJ;AAOG;EACC,iBAAA;EACA,oBAAA;AALJ;AAQG;EACC,iBAAA;EACA,yBAAA;EACA,oBAAA;AANJ;;AAcE;EADD;IAEE,aAAA;IACA,sBAAA;IACA,mBAAA;EAVD;AACF;AAYE;EACC,mBAAA;AAVH;AAaE;EACC,YAAA;EACA,mCAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,kCAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;AAXH;AAaG;EACC,mCAAA;EAEA,4CAAA;EACA,wCAAA;EACA,gBAAA;AAZJ;AAeG;EACC,iBAAA;AAbJ;;AAmBA;EACC,gBAAA;EACA,YAAA;AAhBD;AAkBC;EACC,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;AAhBF;AAkBE;EACC,kBAAA;AAhBH;AAoBC;EACC,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAlBF;AAoBE;EACC,mBAAA;AAlBH;AAqBE;EACC,2BAAA;AAnBH;AAwBE;EACC,mBAAA;AAtBH;AA0BC;EACC,aAAA;EACA,uBAAA;AAxBF;AA2BC;EACC,YAAA;AAzBF;;AA8BC;EACC,YAAA;EACA,mBAAA;AA3BF;AA6BE;EACC,aAAA;EACA,uBAAA;AA3BH;AA+BC;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA7BF;;AAkCC;EACC,aAAA;EACA,oBAAA;AA/BF;AAiCE;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,wCAAA;AA/BH;AAmCC;EACC,aAAA;EACA,SAAA;AAjCF;;AAsCC;EACC,aAAA;AAnCF;AAsCC;EACC,aAAA;EACA,oCAAA;AApCF;AAsCE;EACC,wCAAA;EACA,YAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;AApCH;AAsCG;EACC,2BAAA;AApCJ;AAwCE;EACC,sCAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AAtCH;;AA2CA;EACC,aAAA;EACA,SAAA;AAxCD;;AA2CA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AAxCD;AA0CC;EACC,aAAA;AAxCF;AA2CC;EACC,gBAAA;AAzCF;AA2CE;EACC,mBAAA;AAzCH;AA4CE;EACC,aAAA;EACA,oBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,oBAAA;AA1CH;AA4CG;EACC,wBAAA;EACA,sCAAA;EACA,4CAAA;AA1CJ;AA6CG;EACC,wCAAA;AA3CJ;AA8CG;EACC,wCAAA;AA5CJ;AA+CG;EACC,wCAAA;AA7CJ;AAkDC;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AAhDF;AAmDC;EACC,aAAA;EACA,eAAA;EACA,uBAAA;EACA,2BAAA;AAjDF;AAmDE;EACC,kBAAA;AAjDH;AAoDE;EACC,eAAA;AAlDH;AAoDG;EACC,6BAAA;AAlDJ;;AAwDA;EACC,YAAA;AArDD;AAuDC;EACC,0CAAA;EACA,cAAA;AArDF;;AAyDA;EACC,YAAA;AAtDD;AAwDC;EACC,iBAAA;AAtDF;;AA0DA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAvDD;AAyDC;EACC,gBAAA;EACA,kBAAA;AAvDF;AAyDE;EACC,mBAAA;AAvDH;AA0DE;EACC,aAAA;EACA,oBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,wCAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;AAxDH;AA0DG;EACC,wBAAA;EACA,sCAAA;EACA,4CAAA;AAxDJ;AA6DC;EACC,oBAAA;EACA,6CAAA;AA3DF;AA6DE;EACC,aAAA;EACA,8BAAA;EACA,SAAA;AA3DH;AA6DG;EACC,cAAA;AA3DJ;AA8DG;EACC,UAAA;EACA,kBAAA;AA5DJ;AAiEC;EACC,aAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AA/DF;;AAmEA;EACC,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AAhED;;AAmEA;EACC;IACC,4BAAA;EAhEA;EAmED;IACC,wBAAA;EAjEA;AACF;AAqEC;EACC,aAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,0CAAA;EACA,mBAAA;AAnEF;AAqEE;EACC,eAAA;EACA,yBAAA;EACA,sCAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AAnEH;AAsEE;EACC,YAAA;EACA,qBAAA;AApEH;;AAyEA;EACC,aAAA;EACA,uBAAA;EACA,gBAAA;AAtED;AAwEC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAtEF;;AA0EA;EACC,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAvED;AAyEC;EACC,aAAA;EACA,uBAAA;EACA,WAAA;AAvEF;;AA2EA;EACC,aAAA;EACA,8BAAA;EACA,YAAA;AAxED;;AA2EA;EACC,aAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,0CAAA;EACA,8BAAA;AAxED;AA0EC;EACC,YAAA;EACA,kBAAA;AAxEF;AA2EC;EACC,aAAA;EACA,mBAAA;AAzEF;AA4EC;EACC,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;AA1EF;AA4EE;EACC,gBAAA;AA1EH;AA6EE;EACC,iBAAA;EACA,4BAAA;AA3EH;;AAgFA;EACC,YAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AA7ED;AA+EC;EACC,aAAA;EACA,uBAAA;AA7EF;;AAiFA;EACC,YAAA;AA9ED;AAgFC;EACC,aAAA;EACA,kCAAA;EACA,sBAAA;EACA,oCAAA;EACA,WAAA;EACA,mBAAA;EAEA,cAAA;EAEA,mBAAA;EACA,eAAA;AAhFF;AAkFE;EACC,sBAAA;EACA,kBAAA;AAhFH;AAmFE;EACC,sCAAA;EACA,yBAAA;EACA,oBAAA;EACA,sCAAA;EACA,gBAAA;AAjFH;AAmFG;EACC,4BAAA;AAjFJ;AAoFG;EACC,4BAAA;AAlFJ;AAsFE;EAEC,oBAAA;EACA,sCAAA;EACA,wBAAA;AApFH;AAsFG;EACC,4BAAA;AApFJ;AAuFG;EACC,4BAAA;AArFJ;AA2FE;EACC,mBAAA;EACA,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;EACA,eAAA;AAzFH;AA4FE;EACC,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,wCAAA;EACA,eAAA;AA1FH;AA6FE;EACC,aAAA;EACA,sCAAA;EACA,SAAA;AA3FH;AA+FC;EACC,mBAAA;EACA,wCAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,oCAAA;EACA,oCAAA;AA7FF;AAgGC;EACC,aAAA;EACA,WAAA;EACA,qCAAA;EACA,SAAA;AA9FF;AAgGE;EACC,wCAAA;EACA,aAAA;EACA,mBAAA;AA9FH;AAkGC;EACC,mBAAA;EACA,kBAAA;AAhGF;AAmGC;EACC,aAAA;EACA,WAAA;EACA,qCAAA;EACA,SAAA;AAjGF;AAmGE;EACC,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAjGH;AAmGG;EACC,sCAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;AAjGJ;;AAuGA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,4BAAA;EACA,mBAAA;EACA,oCAAA;EACA,YAAA;EACA,SAAA;EACA,4CAAA;AApGD;AAsGC;EACC,aAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,mCAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AApGF;AAuGC;EACC,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,SAAA;EACA,qBAAA;AArGF;AAuGE;EAbD;IAcE,YAAA;IACA,eAAA;EApGD;AACF;AAsGE;EACC,aAAA;EACA,8BAAA;EACA,eAAA;EACA,eAAA;AApGH;;AAyGA;EACC,aAAA;AAtGD;;AAyGA;EACC,aAAA;EACA,SAAA;AAtGD","sourcesContent":["@import '../variables/breakpoints';\n\n.upper {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-bottom: 2rem;\n\n\t@media only screen and (max-width: $bp-600) {\n\t\tmargin-top: 4rem;\n\t\tflex-direction: column;\n\t}\n\n\t&__title {\n\t\twidth: 38rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\t&_shape {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tfont-size: var(--default-font-h2);\n\t\t\tfont-weight: 700;\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t\twidth: 9rem;\n\t\t\theight: 9rem;\n\t\t\tborder-radius: 9rem;\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\t}\n}\n\n.main {\n\t&__nav {\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t}\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\n\t\t&_item {\n\t\t\twidth: 38rem;\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tborder-radius: 1rem;\n\t\t\tpadding: 1.9rem 1rem;\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: 1fr 8fr 1fr;\n\t\t\tgap: 1rem;\n\t\t\talign-items: center;\n\t\t\tcursor: pointer;\n\t\t\ttransition: all 0.2s;\n\n\t\t\t&:hover {\n\t\t\t\tborder: 2px solid var(--color-primary);\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\t\t\tbackground-color: var(--color-primary-3);\n\t\t\t}\n\n\t\t\t&__icon {\n\t\t\t\tfont-size: 2.5rem;\n\t\t\t\ttransition: all 0.2s;\n\t\t\t}\n\n\t\t\t&__icon2 {\n\t\t\t\tfont-size: 2.5rem;\n\t\t\t\ttransform: rotateZ(90deg);\n\t\t\t\ttransition: all 0.2s;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.sub {\n\t&__nav {\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t}\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\n\t\t&_item {\n\t\t\twidth: 36rem;\n\t\t\tborder: 1px solid var(--color-dark);\n\t\t\tborder-radius: 1rem;\n\t\t\tpadding: 1.9rem 1rem;\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: 1fr 8fr 1fr;\n\t\t\tgap: 1rem;\n\t\t\talign-items: center;\n\t\t\tcursor: pointer;\n\t\t\ttransition: all 0.2s;\n\t\t\tmargin-left: 2rem;\n\n\t\t\t&:hover {\n\t\t\t\tborder: 2px solid var(--color-dark);\n\t\t\t\t// color: var(--color-primary);\n\t\t\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\t\t\tbackground-color: var(--color-light-gry);\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\n\t\t\t&__icon {\n\t\t\t\tfont-size: 2.5rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.bus {\n\tmargin-top: 1rem;\n\twidth: 40rem;\n\n\t&__head {\n\t\tdisplay: flex;\n\t\tjustify-content: space-evenly;\n\t\talign-items: center;\n\t\tmargin-bottom: 2rem;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 2rem;\n\t\t}\n\t}\n\n\t&__edit {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tfont-size: 2.5rem;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\n\t\t&:hover {\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\t}\n\n\t&__details {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\t}\n\n\t&__img {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n\n\t&__logo {\n\t\theight: 7rem;\n\t}\n}\n\n.sec {\n\t&__img {\n\t\twidth: 25rem;\n\t\tmargin-bottom: 3rem;\n\n\t\t&_contain {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t}\n\t}\n\n\t&__center {\n\t\twidth: 40rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n}\n\n.am {\n\t&__img {\n\t\theight: 10rem;\n\t\tborder-radius: 10rem;\n\n\t\t&_contain {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\twidth: 12rem;\n\t\t\theight: 12rem;\n\t\t\tborder-radius: 12rem;\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t}\n\t}\n\n\t&__btn {\n\t\tdisplay: flex;\n\t\tgap: 2rem;\n\t}\n}\n\n.if {\n\t&__img {\n\t\theight: 22rem;\n\t}\n\n\t&__share {\n\t\tdisplay: flex;\n\t\tfont-size: var(--default-font-small);\n\n\t\t&_1 {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t\twidth: 28rem;\n\t\t\tpadding: 1.5rem 2rem;\n\t\t\tborder-radius: 2rem 0 0 2rem;\n\t\t\tword-wrap: break-word;\n\n\t\t\tspan {\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\n\t\t&_2 {\n\t\t\tbackground-color: var(--color-primary);\n\t\t\tcolor: var(--color-white);\n\t\t\twidth: 10rem;\n\t\t\tpadding: 1.5rem 2rem;\n\t\t\tborder-radius: 0 2rem 2rem 0;\n\t\t\tword-wrap: break-word;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\ttext-align: center;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n}\n\n.logout {\n\tdisplay: flex;\n\tgap: 2rem;\n}\n\n.cs {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\n\t&__img {\n\t\theight: 23rem;\n\t}\n\n\t&__menu {\n\t\tmargin-top: 3rem;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\n\t\t&_main {\n\t\t\tdisplay: flex;\n\t\t\tpadding: 2.5rem 2rem;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\tfont-size: 3rem;\n\t\t\twidth: 42rem;\n\t\t\tborder-radius: 1.5rem;\n\t\t\tcursor: pointer;\n\t\t\ttransition: all 0.2s;\n\n\t\t\t&:hover {\n\t\t\t\tfilter: brightness(1.05);\n\t\t\t\tborder: 1px solid var(--color-primary);\n\t\t\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.15);\n\t\t\t}\n\n\t\t\t&__faq {\n\t\t\t\tbackground-color: var(--color-primary-3);\n\t\t\t}\n\n\t\t\t&__send {\n\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t}\n\n\t\t\t&__speak {\n\t\t\t\tbackground-color: var(--color-primary-8);\n\t\t\t}\n\t\t}\n\t}\n\n\t&__dials {\n\t\tdisplay: flex;\n\t\tgap: 2rem;\n\t\talign-items: center;\n\t\tfont-size: 3rem;\n\t\tmargin-bottom: 2rem;\n\t\tcursor: pointer;\n\t}\n\n\t&__socials {\n\t\tdisplay: flex;\n\t\tfont-size: 3rem;\n\t\tjustify-content: center;\n\t\tcolor: var(--color-primary);\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 2rem;\n\t\t}\n\n\t\t& > * {\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--color-primary-4);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.faq {\n\twidth: 42rem;\n\n\t&__line {\n\t\tborder-top: 1px solid var(--color-primary);\n\t\tmargin: 1rem 0;\n\t}\n}\n\n.pin {\n\twidth: 38rem;\n\n\t& > :nth-child(3) {\n\t\tmargin-left: 4rem;\n\t}\n}\n\n.iconfig {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\n\t&__menu {\n\t\tmargin-top: 3rem;\n\t\ttransition: all 2s;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\n\t\t&_main {\n\t\t\tdisplay: flex;\n\t\t\tpadding: 2.5rem 2rem;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\tfont-size: 3rem;\n\t\t\twidth: 42rem;\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t\tborder-radius: 1.5rem;\n\t\t\ttransition: all 0.2s;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tfilter: brightness(1.05);\n\t\t\t\tborder: 1px solid var(--color-primary);\n\t\t\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.15);\n\t\t\t}\n\t\t}\n\t}\n\n\t&__settings {\n\t\tpadding: 2rem 1.8rem;\n\t\tanimation: translateDown 0.5s;\n\n\t\t&_feature {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\tgap: 2rem;\n\n\t\t\t&:not(:last-child) {\n\t\t\t\tmargin: 2rem 0;\n\t\t\t}\n\n\t\t\t&_text {\n\t\t\t\twidth: 80%;\n\t\t\t\talign-self: center;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\twidth: 38rem;\n\t\tflex-wrap: wrap;\n\t}\n}\n\n.error {\n\tfont-size: var(--default-font-small);\n\tcolor: var(--color-error);\n\tpadding-left: 2rem;\n\tfont-weight: 400;\n\tmargin: 1rem 0;\n\twidth: 38rem;\n}\n\n@keyframes translateDown {\n\t0% {\n\t\ttransform: translateY(-10px);\n\t}\n\n\t100% {\n\t\ttransform: translateY(0);\n\t}\n}\n\n.kyc {\n\t&__list {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\twidth: 38rem;\n\t\tpadding-bottom: 2rem;\n\t\tborder-bottom: 1px solid var(--color-grey);\n\t\tmargin-bottom: 2rem;\n\n\t\t&__icon {\n\t\t\tfont-size: 4rem;\n\t\t\tcolor: var(--color-green);\n\t\t\tbackground-color: var(--color-green-3);\n\t\t\tborder-radius: 5rem;\n\t\t\tpadding: 0.5rem;\n\t\t\tbox-sizing: border-box;\n\t\t\tmargin-right: 1rem;\n\t\t}\n\n\t\tspan {\n\t\t\twidth: 33rem;\n\t\t\tword-wrap: break-word;\n\t\t}\n\t}\n}\n\n.bicContainer {\n\tdisplay: flex;\n\tjustify-content: center;\n\tmax-width: 36rem;\n\n\t&__bic {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-bottom: 2rem;\n\t\twidth: 100%;\n\t\tmax-width: 36rem;\n\t}\n}\n\n.configDetails {\n\tdisplay: grid;\n\tgrid-template-columns: 55% 35%;\n\tmax-width: 40rem;\n\tjustify-content: center;\n\tjustify-self: center;\n\tmargin-bottom: 2rem;\n\tgap: 2rem;\n\tpadding: 0 1rem;\n\n\t&_btn {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\twidth: 100%;\n\t}\n}\n\n.repeat {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\twidth: 38rem;\n}\n\n.cards {\n\tdisplay: flex;\n\twidth: 38rem;\n\talign-items: center;\n\tpadding-bottom: 1rem;\n\tborder-bottom: 1px solid var(--color-grey);\n\tjustify-content: space-between;\n\n\timg {\n\t\theight: 3rem;\n\t\tmargin-right: 3rem;\n\t}\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\n\t&__delete {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-direction: column;\n\t\tcolor: var(--color-error);\n\t\tcursor: pointer;\n\t\tfont-size: 3rem;\n\n\t\t&:hover {\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\tp {\n\t\t\tfont-size: 1.4rem;\n\t\t\tcolor: var(--color-deep-red);\n\t\t}\n\t}\n}\n\n.paystackButton {\n\twidth: 38rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-primary);\n\tcolor: var(--color-white);\n\tfont-weight: 700;\n\tbox-sizing: border-box;\n\tpadding: 1.9rem 2.2rem;\n\tjustify-content: center;\n\tmargin-top: 2rem;\n\n\t&_container {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n}\n\n.subscription {\n\twidth: 42rem;\n\n\t&__planSelect {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr 1fr 1fr;\n\t\tbox-sizing: border-box;\n\t\tfont-size: var(--default-font-small);\n\t\twidth: 100%;\n\t\tborder-radius: 1rem;\n\n\t\tmargin: 1rem 0;\n\n\t\tmargin-bottom: 3rem;\n\t\tcursor: pointer;\n\n\t\t& > * {\n\t\t\tpadding: 1rem 0 1rem 0;\n\t\t\ttext-align: center;\n\t\t}\n\n\t\t&__active {\n\t\t\tbackground-color: var(--color-primary);\n\t\t\tcolor: var(--color-white);\n\t\t\ttransition: all 0.4s;\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tfont-weight: 700;\n\n\t\t\t&__1 {\n\t\t\t\tborder-radius: 1rem 0 0 1rem;\n\t\t\t}\n\n\t\t\t&__2 {\n\t\t\t\tborder-radius: 0 1rem 1rem 0;\n\t\t\t}\n\t\t}\n\n\t\t&__inactive {\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\ttransition: all 0.4s;\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tcolor: var(--color-dark);\n\n\t\t\t&__1 {\n\t\t\t\tborder-radius: 1rem 0 0 1rem;\n\t\t\t}\n\n\t\t\t&__2 {\n\t\t\t\tborder-radius: 0 1rem 1rem 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__planDetails {\n\t\t&__deselected {\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-light);\n\t\t\tmargin-bottom: 2rem;\n\t\t\tpadding: 2rem;\n\t\t\tborder: 1px solid var(--color-grey);\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\t&__selected {\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\tmargin-bottom: 2rem;\n\t\t\tpadding: 2rem;\n\t\t\tborder: 1px solid var(--color-primary-4);\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\t&__item {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: min-content 1fr;\n\t\t\tgap: 1rem;\n\t\t}\n\t}\n\n\t&__save {\n\t\tborder-radius: 1rem;\n\t\tbackground-color: var(--color-light-red);\n\t\tcolor: var(--color-error);\n\t\tfont-weight: 700;\n\t\tpadding: 1rem;\n\t\tborder: 1px solid var(--color-error);\n\t\tfont-size: var(--default-font-small);\n\t}\n\n\t&__summary {\n\t\tdisplay: grid;\n\t\twidth: 100%;\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t\tgap: 2rem;\n\n\t\t&__item {\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\tpadding: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t}\n\t}\n\n\t&__img {\n\t\tmargin-bottom: 2rem;\n\t\twidth: max-content;\n\t}\n\n\t&__upgrade {\n\t\tdisplay: grid;\n\t\twidth: 100%;\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t\tgap: 2rem;\n\n\t\t&__item {\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\tpadding: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\theight: 7.5rem;\n\t\t\tfont-weight: 700;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tcursor: pointer;\n\t\t\ttransition: all 0.2s;\n\n\t\t\t&__active {\n\t\t\t\tborder: 2px solid var(--color-primary);\n\t\t\t\tborder-radius: 1rem;\n\t\t\t\tpadding: 1rem;\n\t\t\t\ttransition: all 0.2s;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ai {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tflex-wrap: wrap;\n\tbox-sizing: border-box;\n\tpadding: 3rem 5rem 3rem 5rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-white);\n\theight: auto;\n\tgap: 2rem;\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\n\t&__copy {\n\t\tdisplay: flex;\n\t\tfont-size: 3rem;\n\t\tcolor: var(--color-white);\n\t\tcursor: pointer;\n\t\tbackground-color: var(--color-dark);\n\t\tpadding: 1rem 2rem;\n\t\tborder-radius: 0.5rem;\n\t\talign-items: center;\n\t}\n\n\t&__card {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tmax-width: 100%;\n\t\tmin-width: 80rem;\n\t\tflex-wrap: wrap;\n\t\tbox-sizing: border-box;\n\t\tpadding: 2rem;\n\t\tborder-radius: 1rem;\n\t\tbackground-color: var(--color-primary-3);\n\t\tgap: 1rem;\n\t\tscroll-behavior: auto;\n\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\theight: auto;\n\t\t\tfont-size: 2rem;\n\t\t}\n\n\t\t&__align {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\tmax-width: 100%;\n\t\t\tflex-wrap: wrap;\n\t\t}\n\t}\n}\n\n.imageUpload {\n\theight: 10rem;\n}\n\n.beside {\n\tdisplay: flex;\n\tgap: 4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upper": `Settings_upper__VkmmB`,
	"upper__title": `Settings_upper__title__k8wwl`,
	"upper__title_shape": `Settings_upper__title_shape__X3-hw`,
	"main__nav": `Settings_main__nav__7J4Il`,
	"main__nav_item": `Settings_main__nav_item__XO2S4`,
	"main__nav_item__icon": `Settings_main__nav_item__icon__Qs5-6`,
	"main__nav_item__icon2": `Settings_main__nav_item__icon2__mFi3W`,
	"sub__nav": `Settings_sub__nav__HWTrS`,
	"sub__nav_item": `Settings_sub__nav_item__OCNaP`,
	"sub__nav_item__icon": `Settings_sub__nav_item__icon__aS4MS`,
	"bus": `Settings_bus__FfqYA`,
	"bus__head": `Settings_bus__head__+iwa1`,
	"bus__edit": `Settings_bus__edit__u-pM8`,
	"bus__details": `Settings_bus__details__UXQRr`,
	"bus__img": `Settings_bus__img__H3nvL`,
	"bus__logo": `Settings_bus__logo__cbPcH`,
	"sec__img": `Settings_sec__img__UBa8n`,
	"sec__img_contain": `Settings_sec__img_contain__pg1nC`,
	"sec__center": `Settings_sec__center__TahHv`,
	"am__img": `Settings_am__img__1DqEQ`,
	"am__img_contain": `Settings_am__img_contain__-SJHU`,
	"am__btn": `Settings_am__btn__9MQlO`,
	"if__img": `Settings_if__img__3br2T`,
	"if__share": `Settings_if__share__BsmS-`,
	"if__share_1": `Settings_if__share_1__obhQz`,
	"if__share_2": `Settings_if__share_2__zcvCB`,
	"logout": `Settings_logout__U3JnU`,
	"cs": `Settings_cs__gIIaj`,
	"cs__img": `Settings_cs__img__r1mT5`,
	"cs__menu": `Settings_cs__menu__RE8EV`,
	"cs__menu_main": `Settings_cs__menu_main__3YUqa`,
	"cs__menu_main__faq": `Settings_cs__menu_main__faq__nSrYx`,
	"cs__menu_main__send": `Settings_cs__menu_main__send__OP8TA`,
	"cs__menu_main__speak": `Settings_cs__menu_main__speak__a8FDJ`,
	"cs__dials": `Settings_cs__dials__mCgL-`,
	"cs__socials": `Settings_cs__socials__eF8CK`,
	"faq": `Settings_faq__eYSCI`,
	"faq__line": `Settings_faq__line__acoxP`,
	"pin": `Settings_pin__4qjSC`,
	"iconfig": `Settings_iconfig__CVqHf`,
	"iconfig__menu": `Settings_iconfig__menu__JlARv`,
	"iconfig__menu_main": `Settings_iconfig__menu_main__F5odO`,
	"iconfig__settings": `Settings_iconfig__settings__knJP-`,
	"translateDown": `Settings_translateDown__EEHVR`,
	"iconfig__settings_feature": `Settings_iconfig__settings_feature__fi1QQ`,
	"iconfig__settings_feature_text": `Settings_iconfig__settings_feature_text__YiTrx`,
	"iconfig__beside": `Settings_iconfig__beside__Rov1s`,
	"error": `Settings_error__B+Z6D`,
	"kyc__list": `Settings_kyc__list__OkdXD`,
	"kyc__list__icon": `Settings_kyc__list__icon__7d40V`,
	"bicContainer": `Settings_bicContainer__Jo9Bc`,
	"bicContainer__bic": `Settings_bicContainer__bic__EYiXy`,
	"configDetails": `Settings_configDetails__f4LiO`,
	"configDetails_btn": `Settings_configDetails_btn__w9tUy`,
	"repeat": `Settings_repeat__0X8Xw`,
	"cards": `Settings_cards__FXfy5`,
	"cards__beside": `Settings_cards__beside__2Z3Xb`,
	"cards__delete": `Settings_cards__delete__k1TSq`,
	"paystackButton": `Settings_paystackButton__iRlxX`,
	"paystackButton_container": `Settings_paystackButton_container__789dN`,
	"subscription": `Settings_subscription__fOuW4`,
	"subscription__planSelect": `Settings_subscription__planSelect__7QnZ5`,
	"subscription__planSelect__active": `Settings_subscription__planSelect__active__Pq8RP`,
	"subscription__planSelect__active__1": `Settings_subscription__planSelect__active__1__7C6nc`,
	"subscription__planSelect__active__2": `Settings_subscription__planSelect__active__2__jTmek`,
	"subscription__planSelect__inactive": `Settings_subscription__planSelect__inactive__53kkk`,
	"subscription__planSelect__inactive__1": `Settings_subscription__planSelect__inactive__1__RL4vY`,
	"subscription__planSelect__inactive__2": `Settings_subscription__planSelect__inactive__2__AfVDX`,
	"subscription__planDetails__deselected": `Settings_subscription__planDetails__deselected__Dgcpu`,
	"subscription__planDetails__selected": `Settings_subscription__planDetails__selected__2G0u4`,
	"subscription__planDetails__item": `Settings_subscription__planDetails__item__4DqSY`,
	"subscription__save": `Settings_subscription__save__upfLx`,
	"subscription__summary": `Settings_subscription__summary__gznLZ`,
	"subscription__summary__item": `Settings_subscription__summary__item__v8OZ6`,
	"subscription__img": `Settings_subscription__img__DoUp2`,
	"subscription__upgrade": `Settings_subscription__upgrade__rttVc`,
	"subscription__upgrade__item": `Settings_subscription__upgrade__item__3rFuK`,
	"subscription__upgrade__item__active": `Settings_subscription__upgrade__item__active__VrVXT`,
	"ai": `Settings_ai__9WDvH`,
	"ai__copy": `Settings_ai__copy__geyfW`,
	"ai__card": `Settings_ai__card__h0SAS`,
	"ai__card__align": `Settings_ai__card__align__RFxmd`,
	"imageUpload": `Settings_imageUpload__URHrl`,
	"beside": `Settings_beside__7hxRx`
};
export default ___CSS_LOADER_EXPORT___;
